<ng-container *ngIf="loyaltyForm" [formGroup]="loyaltyForm">
  <p class="title">{{'BOOKING_MODULE.PAX.LOYALTY.FREQUENT_PROGRAM_LABEL' | transloco}}</p>
  <div class="f-flyer-form-inputs">
    <app-dropdown-select
      [fullWidth]="true"
      [fullHeight]="true"
      [inSwipeUp]="true"
      [withSearchInput]="true"
      [defaultOption]="defaultAirlineProgram$ | async"
      [title]="'BOOKING_MODULE.PROGRAMS' | transloco"
      [selectOptions]="programs | frequentFlyerPrograms : defaultLoyalty : (defaultAirlineProgram$ | async)"
      [scrollFixedPosition]="false"
      [manipulateDOM]="false"
      [orderFirstSelected]="true"
      [isMobile]="isMobile"
      (selected)="onSelectedFrequentFlyerAirline($event)">
    </app-dropdown-select>
  </div>
  <div class="f-flyer-form-inputs">
    <app-form-text-input
      [form]="loyaltyForm"
      [formControlSelector]="flyerSelector"
      [id]="flyerSelector"
      [maxLength]="20"
      [isSubmitted]="isSubmitted"
      [formInputType]="documentInput"
      [inputDocumentType]="alphanumericType"
      [placeholder]="'BOOKING_MODULE.FREQUENT_FLYER_NUMBER' | transloco">
    </app-form-text-input>
  </div>
  <div class="button-form-row">
    <div class="button-container">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.PAX.LOYALTY.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </div>
  </div>
</ng-container>
